import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { CheckmarkIcon } from '@cp/ds/src/icons/checkmark';

export const ListItem: React.FC<{ label: string }> = ({ label }) => (
  <Stack alignItems={'center'} direction="row" gap={1.5} sx={{ mb: 0.75, textAlign: 'start' }}>
    <Stack
      sx={{
        minWidth: '36px',
        minHeight: '36px',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.04)',
      }}
    >
      <CheckmarkIcon fontSize="small" sx={{ color: 'brand pink' }} />
    </Stack>
    <Typography>{label}</Typography>
  </Stack>
);
